/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ActorDefs from './..\\actor\\defs.defs.js'

const $nsid = 'app.bsky.feed.getLikes'

type $nsid = typeof $nsid

export { $nsid }

type Like = {
  $type?: 'app.bsky.feed.getLikes#like'
  actor: ActorDefs.ProfileView
  createdAt: l.DatetimeString
  indexedAt: l.DatetimeString
}

export type { Like }

const like = /*#__PURE__*/ l.typedObject<Like>(
  $nsid,
  'like',
  /*#__PURE__*/ l.object({
    actor: /*#__PURE__*/ l.ref<ActorDefs.ProfileView>(
      (() => ActorDefs.profileView) as any,
    ),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    indexedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
  }),
)

export { like }

export const $params = /*#__PURE__*/ l.params({
  cid: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({ format: 'cid' })),
  uri: /*#__PURE__*/ l.string({ format: 'at-uri' }),
  limit: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(
      /*#__PURE__*/ l.integer({ maximum: 100, minimum: 1 }),
      50,
    ),
  ),
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  cid: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({ format: 'cid' })),
  uri: /*#__PURE__*/ l.string({ format: 'at-uri' }),
  likes: /*#__PURE__*/ l.array(/*#__PURE__*/ l.ref<Like>((() => like) as any)),
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Get like records which reference a subject (by AT-URI and CID). */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
